import { takeLatest, call, put, takeEvery } from 'redux-saga/effects';
import axios from '../axiosConfig';
import {
  searchCustomersSuccess,
  searchCustomersRequest,
  searchCustomerByEmailRequest,
  searchCustomerByEmailResponse,
} from '../../slices/customer';

function* searchCustomersWorker({ payload: { query, customerEmail, pageSize } }) {
  try {
    let url = `/users/search?text=${query || ''}`;
    if (customerEmail) {
      url += `&customerEmail=${customerEmail}`;
    }
    if (pageSize > 0) url += `&pageSize=${pageSize}`;
    const config = {
      method: 'GET',
      url,
    };
    const { data } = yield call(axios, config);
    if (customerEmail) {
      yield put(
        searchCustomerByEmailResponse({
          error: data ? null : 'Problem in search customers!',
          customer: (data || [])[0],
          customerEmail,
        }),
      );
    } else {
      yield put(
        searchCustomersSuccess({
          error: data ? null : 'Problem in search customers!',
          customers: data || [],
        }),
      );
    }
  } catch (error) {
    if (customerEmail) {
      yield put(searchCustomersSuccess({ error: 'Problem in sending request!' }));
    } else {
      yield put(searchCustomersSuccess({ error: 'Problem in sending request!' }));
    }
    console.error(error);
  }
}

function* searchCustomersWatcher() {
  yield takeLatest(searchCustomersRequest.toString(), searchCustomersWorker);
  yield takeEvery(searchCustomerByEmailRequest.toString(), searchCustomersWorker);
}

export default searchCustomersWatcher;
